/**
 * List/view APIs may return thumbnail URLs with a duplicated S3 prefix and the
 * original file name appended after the stored key, e.g.
 * .../class_thumbnails/class_thumbnails/{uuid}.png/{original}.png?...
 * Objects are stored at class_thumbnails/{uuid}.png.
 */
export function normalizeClassThumbnailUrl(
  url: string | null | undefined
): string {
  if (!url?.trim()) return "";

  try {
    const parsed = new URL(url);
    const duplicatePrefixMatch = parsed.pathname.match(
      /^\/class_thumbnails\/class_thumbnails\/([^/]+\.(?:png|jpe?g|webp))\/[^/]+$/i
    );

    if (duplicatePrefixMatch) {
      return `${parsed.origin}/class_thumbnails/${duplicatePrefixMatch[1]}`;
    }

    const canonicalMatch = parsed.pathname.match(
      /^\/class_thumbnails\/([^/]+\.(?:png|jpe?g|webp))$/i
    );
    if (canonicalMatch) {
      // Drop rotating presigned query params so the browser can cache by object key.
      return `${parsed.origin}${parsed.pathname}`;
    }

    return url;
  } catch {
    return url;
  }
}
